import { InputRow, Node } from "./models";

export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export namespace cc {
  type Canceled = {}
  export const canceled: Canceled = {}

  export interface Token {
    cancel?: () => void
  }

  export function wrap<T>(promise: Promise<T>, token: Token): Promise<T | Canceled> {
    let p = new Promise(resolve => token.cancel = () => resolve(canceled))
    return Promise.race([p, promise])
  }
}

export function normalizeModel(model: any, inputs: InputRow[]) {
  for (let input of inputs) {
    let key = input.key
    let value = model[key]
    if (input.widget === 'dict') {
      if (value && typeof value === 'string') {
        try {
          value = model[key] = JSON.parse(value)
        }
        catch (e) {
          value = null 
        }
      }
      if (!value || typeof value !== 'object')
        value = model[key] = {}
      normalizeModel(value, input.inputs)
    }
    else if (input.widget === 'list') {
      if (value && typeof value === 'string') {
        try {
          value = model[key] = JSON.parse(value)
        }
        catch (e) {
          value = null
        }
      }
      if (!value || !Array.isArray(value))
        value = model[key] = []
      for (let i=0; i<value.length; i++) {
        if (typeof value[i] !== 'object') {
          value.splice(i, 1)
          i--;
        }
        else {
          normalizeModel(value[i], input.inputs)
        }
      }
    }
    else {
      if (!value)
        model[key] = ""
      else
        model[key] = value.toString()
    }
  }
  return model
}

export function bakeRemoteData(_model, _inputs) {
  function stringValue(str: any, trim = false) {
    return typeof(str) === 'string' && str.length ? (trim ? str.trim() : str) : null
  }
  function emptyObject(object) {
    for (let k in object) {
      if (object[k])
        return false
    }
    return true
  }
  function bake(model, inputs) {
    let data: any = {}
    for (let input of inputs) {
      if (input.widget === 'image')
        data[input.key] = stringValue(model[input.key], true)
      else if (input.widget === 'dict') {
        let object = bake(model[input.key], input.inputs)
        if (emptyObject(object))
          data[input.key] = null
        else
          data[input.key] = JSON.stringify(object)
      }
      else if (input.widget === 'list') {
        let value = model[input.key]
        if (Array.isArray(value) && value.length)
          data[input.key] = JSON.stringify(value)
        else
          data[input.key] = null
      }
      else if (input.widget === 'checkbox') {
        data[input.key] = model[input.key] ? 1 : 0
      }
      else
        data[input.key] = stringValue(model[input.key])
    }
    return data
  }
  return bake(_model, _inputs)
}

export function genUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9)
}

export function shuffle(list: any[]) {
  let array = Array.from(list)
  let currentIndex = array.length, temporaryValue, randomIndex;
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export namespace liset {
  export function add<T>(list: T[], val: T) {
    let index = list.indexOf(val)
    if (index === -1)
      list.push(val)
  }
  
  export function remove<T>(list: T[], val: T) {
    let index = list.indexOf(val)
    if (index !== -1)
      list.splice(index, 1)
  }
  
  export function toggle<T>(list: T[], val: T) {
    let index = list.indexOf(val)
    if (index !== -1) {
      list.splice(index, 1)
      return false
    }
    else {
      list.push(val)
      return true
    }
  }
}

export namespace tree {
  export function find(node: Node, id: number): Node | null {
    function _get(node: Node): Node | null {
      if (node.id == id)
        return node
      else {
        for (let child of node.children) {
          let result = _get(child)
          if (result)
            return result;
        }
        return null
      }
    }
    return _get(node)
  }

  export function locate(root: Node, id: number): {node: Node, index: number, parent: Node} {
    if (root.id === id)
      throw new Error('Target should be in subtree.')
    let ancestors: Node[] = []
    function _get(node: Node): Node | null {
      if (node.id === id)
        return node
      else {
        ancestors.push(node)
        for (let child of node.children) {
          let result = _get(child)
          if (result)
            return result;
        }
        ancestors.pop()
        return null
      }
    }
    let node = _get(root)
    if (!node)
      throw new Error('Target is not found.')
    let parent = ancestors[ancestors.length - 1]
    let index = parent.children.indexOf(node)
    return {node, index, parent}
  }
}

